import { render, staticRenderFns } from "./rukuShen.vue?vue&type=template&id=77742af2&scoped=true"
import script from "./rukuShen.vue?vue&type=script&lang=js"
export * from "./rukuShen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77742af2",
  null
  
)

export default component.exports